/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

// tslint:disable: ban-types
export class ModelKeyProvider {

  private static readonly modelKeys = new Map<Function, string>();

  static registerKey(constructor: Function, modelKey: string) {
    ModelKeyProvider.modelKeys.set(constructor, modelKey);
  }

  static resolveKey(model: Function | object): string {
    const constructor: Function = typeof model === 'function' ? model : model.constructor;
    return ModelKeyProvider.modelKeys.get(constructor);
  }
}

